import api from '@/api'
import {
  SET_EXCHANGERATE_LIST,
} from './mutation-types'

const state = {
  latestRate: 1,
  historyNoticeList: [],
}

const mutations = {
  [SET_EXCHANGERATE_LIST] (state, payload) {
    state.latestRate = payload
  },
}

const actions = {
  // 查询汇率列表
  async getLatestExchangeRate ({commit}) {
    const {data} = await api.deployApi.checkExchangeRateList()
    commit(SET_EXCHANGERATE_LIST, data[0].rate)
  },
  // 更新汇率
  async updateExchangeRate ({commit, dispatch}, payload) {
    const result = await api.deployApi.updateRate(payload)
    dispatch('getLatestExchangeRate')
    return result
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
